// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as Throttle$Showside from "../utils/Throttle.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as IframeEmbed$Showside from "../utils/IframeEmbed.bs.js";
import * as ReactZoomPanPinch from "react-zoom-pan-pinch";
import * as QuickViewTabs$Showside from "./QuickViewTabs.bs.js";
import * as QuickViewMedia$Showside from "./QuickViewMedia.bs.js";
import * as UseAutoplayProgress$Showside from "../hook/UseAutoplayProgress.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function ImageSlider(Props) {
  var product = Props.product;
  var selectedVariant = Props.selectedVariant;
  var settings = Props.settings;
  var selectedSlideOpt = Props.selectedSlide;
  var visibleOpt = Props.visible;
  var onChange = Props.onChange;
  var currentSlide = Props.currentSlide;
  var selectedSlide = selectedSlideOpt !== undefined ? selectedSlideOpt : true;
  var visible = visibleOpt !== undefined ? visibleOpt : true;
  var match = LCPContext$Showside.use(undefined);
  var onMainImageRendered = match.onMainImageRendered;
  var hideMediaFromOtherVariants = Belt_Option.mapWithDefault(ConfigurationProvider$Showside.use(undefined).config.transitiveAccount, false, function (account) {
    return account.pdpHideMediaFromOtherVariants;
  });
  var allVariantMedia = React.useMemo(function () {
    return Product$Showside.getAllVariantMedia(hideMediaFromOtherVariants, product, selectedVariant);
  }, [selectedVariant.id, product.id]);
  var match$1 = React.useState(function () {
    return false;
  });
  var setZoomed = match$1[1];
  var zoomed = match$1[0];
  var handleZoom = function (ref, $$event) {
    Curry._1(setZoomed, function (param) {
      return ref.state.scale > 2;
    });
  };
  var match$2 = Throttle$Showside.use(undefined, undefined, function (param) {
    return 0;
  });
  var setSelectedImage = match$2[1];
  var selectedImage = match$2[0];
  React.useEffect(function () {
    if (currentSlide !== undefined) {
      Curry._1(setSelectedImage, function (param) {
        return currentSlide;
      });
    }
  }, [currentSlide]);
  var match$3 = React.useState(function () {
    if (selectedSlide) {
      return visible;
    } else {
      return false;
    }
  });
  var setAutoplay = match$3[1];
  var autoplay = match$3[0];
  React.useEffect(function () {
    Curry._1(setAutoplay, function (param) {
      if (selectedSlide) {
        return visible;
      } else {
        return false;
      }
    });
  }, [selectedSlide, visible]);
  var image = Belt_Array.get(allVariantMedia, selectedImage);
  var mediaSrc = Belt_Option.flatMap(image, Product$Showside.Media.getImageUrl);
  var match$4 = UseAutoplayProgress$Showside.use(autoplay, undefined, Belt_Option.map(image, function (image) {
    switch (image.TAG | 0) {
      case /* Image */0:
        return "image";
      case /* Video */1:
        return "video";
      case /* IframeEmbed */2:
        return "iframe";
    }
  }), mediaSrc, undefined);
  var setProgress = match$4[1];
  var match$5 = React.useState(function () {
    return false;
  });
  var setAutoplayPaused = match$5[1];
  var autoplayPaused = match$5[0];
  var autoplayPausedRef = React.useRef(false);
  var loadedRef = React.useRef([]);
  var match$6 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var $$clearTimeout$1 = match$6.clearTimeout;
  var $$setTimeout$1 = match$6.setTimeout;
  var isLoaded = function (src) {
    return Belt_Array.some(loadedRef.current, function (k) {
      return k === src;
    });
  };
  var setLoaded = function (src) {
    loadedRef.current = Belt_Array.concat(loadedRef.current, [src]);
  };
  var pauseAutoplay = function (value) {
    autoplayPausedRef.current = value;
    Curry._1(setAutoplayPaused, function (param) {
      return value;
    });
  };
  React.useEffect(function () {
    if (mediaSrc !== undefined) {
      pauseAutoplay(!isLoaded(mediaSrc));
    }
  }, [mediaSrc, selectedSlide, visible]);
  var handleTouchStart = function (param) {
    Curry._1($$clearTimeout$1, undefined);
    $$setTimeout$1(function (param) {
      if (mediaSrc !== undefined && isLoaded(mediaSrc)) {
        return pauseAutoplay(true);
      }
    }, 250);
  };
  var handleTouchEnd = function (param) {
    Curry._1($$clearTimeout$1, undefined);
    $$setTimeout$1(function (param) {
      if (mediaSrc !== undefined && isLoaded(mediaSrc)) {
        return pauseAutoplay(false);
      }
    }, 42);
  };
  var mediaCount = allVariantMedia.length;
  var nextImage = function (param) {
    if (!autoplayPausedRef.current || Belt_Option.mapWithDefault(mediaSrc, false, isLoaded) === false) {
      Curry._1(setProgress, 0);
      return Curry._1(setSelectedImage, function (image) {
        var next = image + 1 | 0;
        var next$1 = next >= mediaCount ? 0 : next;
        Curry._1(onChange, next$1);
        return next$1;
      });
    }
  };
  var prevImage = function (param) {
    if (!autoplayPausedRef.current || Belt_Option.mapWithDefault(mediaSrc, false, isLoaded) === false) {
      Curry._1(setProgress, 0);
      return Curry._1(setSelectedImage, function (image) {
        var prev = image - 1 | 0;
        var prev$1 = prev < 0 ? mediaCount - 1 | 0 : prev;
        Curry._1(onChange, prev$1);
        return prev$1;
      });
    }
  };
  var autoplayTimerRef = React.useRef(undefined);
  React.useEffect(function () {
    var $$clearTimeout$2 = function (param) {
      var id = autoplayTimerRef.current;
      if (id !== undefined) {
        clearTimeout(Caml_option.valFromOption(id));
        return;
      }
    };
    $$clearTimeout$2(undefined);
    if (image !== undefined) {
      switch (image.TAG | 0) {
        case /* Image */0:
          if (autoplayPaused || !autoplay) {} else {
            autoplayTimerRef.current = Caml_option.some(setTimeout(nextImage, 5000));
          }
          break;
        case /* Video */1:
        case /* IframeEmbed */2:
          break;
      }
    }
    return function (param) {
      $$clearTimeout$2(undefined);
    };
  }, [Belt_Option.flatMap(image, Product$Showside.Media.getImageUrl), autoplayPaused, autoplay]);
  var handleTimeChange = function (time, duration) {
    Curry._1(setProgress, Math.round(time / duration * 100) | 0);
  };
  var handleContextMenu = function (e) {
    e.preventDefault();
  };
  var tmp = {
    index: selectedImage,
    total: mediaCount,
    onClick: function (i) {
      Curry._1(setSelectedImage, function (param) {
        return i;
      });
      Curry._1(onChange, i);
    },
    autoplay: autoplay,
    autoplayPaused: autoplayPaused,
    setProgressRef: match$4[2],
    enableTruncation: true,
    isMobile: true,
    dataTestId: "pdp-images-tabs"
  };
  var tmp$1 = Belt_Option.flatMap(image, Product$Showside.Media.getImageUrl);
  if (tmp$1 !== undefined) {
    tmp.mediaId = tmp$1;
  }
  var tmp$2 = match$4[0];
  if (tmp$2 !== undefined) {
    tmp.progressSpeed = tmp$2;
  }
  return React.createElement(ReactZoomPanPinch.TransformWrapper, {
    panning: {
      disabled: !zoomed
    },
    doubleClick: {
      disabled: true
    },
    onZoom: handleZoom,
    children: React.createElement(ReactZoomPanPinch.TransformComponent, {
      wrapperClass: CSS$Showside.prefix("absolute inset-0 w-full h-full"),
      contentClass: CSS$Showside.prefix("absolute inset-0 w-full h-full"),
      children: React.createElement(React.Fragment, undefined, Belt_Array.mapWithIndex(allVariantMedia, function (param, param$1) {
        var priority = Math.abs(selectedImage - param | 0);
        var tmp;
        switch (param$1.TAG | 0) {
          case /* Video */1:
            var src = Belt_Option.map(Product$Showside.getVideoSource(param$1._0), function (source) {
              return source.url;
            });
            tmp = Belt_Option.getWithDefault(src, String(param));
            break;
          case /* Image */0:
          case /* IframeEmbed */2:
            tmp = param$1._0.url;
            break;
        }
        var match = settings.newMobilePDPCover;
        var match$1 = settings.backdropBlur;
        var tmp$1;
        switch (param$1.TAG | 0) {
          case /* Image */0:
            var url = param$1._0.url;
            tmp$1 = React.createElement(SmartImg$Showside.make, {
              src: url,
              fit: settings.newMobilePDPCover ? /* Cover */1 : /* ScaleDown */0,
              priority: priority,
              onLoad: function (param) {
                if (param.imageSize.width >= param.width) {
                  setLoaded(url);
                  if (Caml_obj.equal(url, mediaSrc)) {
                    return pauseAutoplay(false);
                  } else {
                    return;
                  }
                }
              },
              onRender: function (param) {
                if (priority === 0) {
                  return Curry._1(onMainImageRendered, undefined);
                }
              },
              noFlicker: true
            });
            break;
          case /* Video */1:
            var video = param$1._0;
            var src$1 = Belt_Option.map(Product$Showside.getVideoSource(video), function (source) {
              return source.url;
            });
            if (src$1 !== undefined) {
              var tmp$2 = {
                src: src$1,
                isPaused: priority > 0 || autoplayPaused || !autoplay,
                onReady: function (param) {
                  setLoaded(src$1);
                  return pauseAutoplay(false);
                },
                onTimeChange: handleTimeChange,
                muted: false,
                onEnded: nextImage,
                loop: false,
                controls: false,
                objectFit: settings.newMobilePDPCover ? "cover" : "contain"
              };
              if (video.posterUrl !== undefined) {
                tmp$2.poster = Caml_option.valFromOption(video.posterUrl);
              }
              tmp$1 = React.createElement(QuickViewMedia$Showside.Video.make, tmp$2);
            } else {
              tmp$1 = null;
            }
            break;
          case /* IframeEmbed */2:
            tmp$1 = React.createElement(IframeEmbed$Showside.make, {
              url: param$1._0.url
            });
            break;
        }
        return React.createElement("div", {
          key: tmp,
          className: CSS$Showside.prefix(Cn.make(["flex items-center justify-center absolute inset-0 overflow-hidden", priority > 0 ? priority >= 3 ? "hidden" : "opacity-0" : priority >= 0 ? "" : "hidden"]))
        }, match || !match$1 ? null : zoomed ? React.createElement("div", {
          className: CSS$Showside.prefix("absolute inset-0 bg-black")
        }) : React.createElement(SmartImg$Showside.ColorOverlay.make, {
          media: param$1
        }), tmp$1);
      }), React.createElement("div", {
        className: CSS$Showside.prefix("absolute inset-0"),
        style: {
          background: "linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 20.31%, rgba(0, 0, 0, 0) 69.79%, rgba(0, 0, 0, 0.5) 100%)"
        }
      }), React.createElement("div", {
        className: CSS$Showside.prefix("absolute inset-0 flex justify-between items-stetch no-touch-callout no-user-select"),
        onContextMenu: handleContextMenu,
        onTouchCancel: handleTouchEnd,
        onTouchEnd: handleTouchEnd,
        onTouchStart: handleTouchStart
      }, React.createElement("div", {
        className: CSS$Showside.prefix("w-1/4 h-full"),
        onClick: prevImage
      }), React.createElement("div", {
        className: CSS$Showside.prefix("w-3/4 h-full"),
        onClick: nextImage
      })), React.createElement(QuickViewTabs$Showside.make, tmp))
    })
  });
}
ImageSlider.displayName = "ImageSlider";
var make = ImageSlider;
export { make };
/* react Not a pure module */